
<div class="row">
    <div class="col-12">
  
        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'INTEGRATION.SETTING_API' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-primary btn-sm btn-pos-i btn-back" routerLink="/integration">
                        <!-- <i class="bi bi-arrow-left-square"></i> -->
                        {{ 'BACK' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm btn-create" (click)="generateApi()">
                        <!-- <i class="bi bi-plus-circle"></i>  -->
                        {{ 'ADD' | translate }}
                    </button>
                </div>
            </div>
            <div class="card-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="key">{{ 'INTEGRATION.KEY' | translate }}</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="apiList.length > 0">
                        <tr *ngFor="let api of apiList">
                            <td class="name">{{ api.apikey }}</td>
                            <td class="action">
                                <button type="button" class="btn btn-light" (click)="copyLink(api.apikey)"
                                ngbTooltip="{{ 'INTEGRATION.COPY_KEY' | translate }}">
                                    <i class="bi bi-link"></i>
                                </button>
                                 <button type="button" class="btn btn-light" (click)="onConfirm([api.id])"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="apiList.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="2">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="2">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>

    </div>
</div>